import { Injectable, signal, Signal } from "@angular/core";
import { SaveableComponent } from "src/app/shared/interfaces/saveable-component";

@Injectable({ providedIn: 'root' })
export class SaveableTrackerService {
  private currentSaveable = signal<SaveableComponent | null>(null);

  set(component: SaveableComponent | null) {
    this.currentSaveable.set(component);
  }

  get(): Signal<SaveableComponent | null> {
    return this.currentSaveable;
  }
}